<template>
    <div
        class="assignment-default-list-label"
        :class="{ editing: edit }">
        <label
            v-show="!edit"
            :for="`assignment-default-list-${itemIn.id}`"
            @click="enableEditMode">
            {{ value }}
        </label>

        <b-input-group
            class="edit-standard-list-question"
            v-if="edit">
            <b-form-input
                v-model="value"
                :id="`assignment-default-list-${itemIn.id}`"
                :ref="`assignment-default-list-${itemIn.id}`"
                @change="updateQuestionTitle()"
                @blur="edit = false"></b-form-input>
            <b-input-group-append>
                <b-button
                    class="btn-checked btn-save"
                    variant="success"></b-button>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>

<script>
import { CommonBus } from '../../../../../../../app';

export default {
    name: 'design-2021-lesson-module-assignment-type-assignment-part-list-item-component',
    props: ['itemIn'],
    data() {
        return {
            edit: false,
            value: this.itemIn.value,
        };
    },
    watch: {
        partIn: function (item) {
            this.value = item.value;
        },
    },
    methods: {
        enableEditMode() {
            const name = `assignment-default-list-${this.itemIn.id}`;
            this.edit = true;
        },

        updateQuestionTitle() {
            if (!this.value) {
                this.value = this.itemIn.value;
                return;
            }

            const data = {
                part_id: this.itemIn.part_id,
                item_id: this.itemIn.id,
                value: this.value,
            };

            this.axios.post(this.routes.assignmentPartListItemUpdate(data.part_id, data.item_id), data).then(
                (response) => {
                    this.$emit('list-item-updated', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    mounted() {
        CommonBus.$on('enable-edit-mode', () => {
            this.enableEditMode();
        });
    },
};
</script>

<style scoped lang="scss">
.assignment-default-list-label {
    align-self: center;

    label {
        margin-bottom: 0;
    }

    input {
        display: none;
        margin-bottom: 0;
        border: 1px solid $border-color;
    }

    &.editing {
        input {
            display: block;
        }
    }

    &.editing {
        width: 100%;
    }

    .edit-standard-list-question {
        .btn-save {
            color: $white;
            border-top-right-radius: $border-radius-content;
            border-bottom-right-radius: $border-radius-content;

            &:before {
                margin-right: 0;
            }
        }

        input {
            &:focus {
                outline: none;
                box-shadow: none;
            }
        }

        &:focus-within {
            border-radius: $border-radius-content;
            box-shadow: 0 0 0 0.2rem rgba($primary, 0.25);
        }
    }
}
</style>
